import { cva } from 'class-variance-authority';

const gradientVariants = cva('bg-gradient-to-br', {
  variants: {
    variant: {
      green: 'from-light-green to-dark-green',
      'orange-yellow': 'from-custom-orange to-custom-yellow',
      'purple-blue': 'from-custom-purple to-custom-blue/80',
      'purple-blue-header':
        '[background:linear-gradient(283deg,rgba(35,112,202,0.80)_-56.86%,rgba(130,10,221,0.80)_47.25%)]',
      'pink-red': 'from-custom-pink to-custom-red',
      'transparent-white': 'from-white/0 to-white/[0.06]',
      'bg-blop': 'from-custom-purple to-custom-blue opacity-70',
      'bg-medium-blop':
        'from-custom-light-blue/70 to-custom-light-purple opacity-50 bg-gradient-to-tr',
      'bg-large-blop': 'from-electric-blue/70 to-electric-blue opacity-10',
      'chart-primary-color':
        'from-custom-blue to-custom-purple bg-gradient-to-t',
      dropdown: 'from-dropdown-purple to-dropdown-blue',
      overlay: 'from-overlay-purple to-overlay-blue',
      'turquoise-blue-green':
        'from-custom-turquoise-blue to-custom-turquoise-green',
    },
  },
});

const greenGradient = gradientVariants({ variant: 'green' });

const orangeYellowGradient = gradientVariants({ variant: 'orange-yellow' });

const purpleBlueGradient = gradientVariants({ variant: 'purple-blue' });

const pinkRedGradient = gradientVariants({ variant: 'pink-red' });

const dropdownGradient = gradientVariants({ variant: 'dropdown' });

const transparentWhiteGradient = gradientVariants({
  variant: 'transparent-white',
});

const bgBlopGradient = gradientVariants({ variant: 'bg-blop' });

const bgMediumBlopGradient = gradientVariants({
  variant: 'bg-medium-blop',
});

const bgLargeBlopGradient = gradientVariants({
  variant: 'bg-large-blop',
});

const overlayGradient = gradientVariants({ variant: 'overlay' });

const purpleBlueHeaderGradient = gradientVariants({
  variant: 'purple-blue-header',
});

const turquoiseBlueGreenGradient = gradientVariants({
  variant: 'turquoise-blue-green',
});

export const Gradients = {
  greenGradient,
  orangeYellowGradient,
  purpleBlueGradient,
  purpleBlueHeaderGradient,
  pinkRedGradient,
  transparentWhiteGradient: transparentWhiteGradient,
  bgBlopGradient,
  bgMediumBlopGradient,
  bgLargeBlopGradient,
  dropdownGradient,
  overlayGradient,
  turquoiseBlueGreenGradient,
};
